// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_HIDE_TERMS = "Skry podmienky";
export const BZ2_SHOW_COMPLETE_TERMS = "Zobraz cel\u00e9 podmienky";
export const BZ2_USER_DETAILS_SHOW_PROFILE = "Profil pou\u017e\u00edvate\u013eky";
export const USER_LIKE = "Pridaj k ob\u013e\u00faben\u00fdm";
export const USER_UNLIKE = "Odober z ob\u013e\u00faben\u00fdch";
